/** Capture on the patient's browser, never on the Remix server. */
export function appendPatientTimezone(form: FormData): void {
  if (typeof window === "undefined") return;
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) form.set("patient_timezone", timezone);
  } catch {
    // Timezone metadata is optional; unsupported browsers can still book.
  }
}
